/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Unranked_Reason_No_FinalInputs */



/**
* | output |
* | --- |
* | "no final" |
*
* @param {Tournament_Unranked_Reason_No_FinalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_unranked_reason_no_final = /** @type {((inputs?: Tournament_Unranked_Reason_No_FinalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Unranked_Reason_No_FinalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("pas de finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("sin final")
	if (locale === "pt") return /** @type {LocalizedString} */ ("sem final")
	if (locale === "it") return /** @type {LocalizedString} */ ("senza finale")
	return /** @type {LocalizedString} */ ("no final")
});